import {GetGtaRateRequest} from "@/Stub/V1";
import {keepPreviousData, useQuery} from "@tanstack/react-query";
import {QueryKeys} from "@/Service/Api/V1/QueryKeys/QueryKeys";
import {GtaRatesApiClient} from "@/Service/Api/V1/ApiClients/GtaRatesApiClient";

export type useGetGtaRateParams = {
    requestParams: GetGtaRateRequest
    enabled?: boolean
    savePreviousData?: boolean
};

export const useGetGtaRate = ({requestParams, enabled, savePreviousData}: useGetGtaRateParams) => useQuery({
    ...QueryKeys.gtaRates.detail(requestParams),
    queryFn: async () => await GtaRatesApiClient.getGtaRate(requestParams),
    enabled,
    gcTime: 0,
    placeholderData: savePreviousData ? keepPreviousData : undefined
});